export default __webpack_public_path__ + "static/media/modalStart.98420008.png";